const drawer = (state = {}, action) => {
  switch (action.type) {
    case "OPEN_DRAWER":
      return Object.assign({}, state, { isOpen: true });

    case "CLOSE_DRAWER":
      return Object.assign({}, state, { isOpen: false });
    default:
      return state;
  }
};

export default drawer;



// WEBPACK FOOTER //
// ./src/reducers/drawer.js